import React from 'react';
import nt_standing from '../img/nt_standing.png';
import nt_main from '../img/nt_main.jpg';
const WhyMe = (props) => 
    { 
    
    

    if (props.lang === "EN") {
        return (
            <div class="content-wrapper">  
            <div>
               I support people who need both psychological depth and strategic 
               clarity. My work combines psychological methods combined with coaching structure, helping
                people organise their thoughts, 
               stabilise their emotions and take clear,grounded decisions.
            </div>
            <div>My approach is calm, direct and results in meaningful reflection. I read emotional
                 patterns quickly and help clients see what sits behind their behaviour, 
                 choices and internal dynamics. The goal is not short inspiration 
                but real psychological clarity that leads to lasting change.
            </div>
            <div>
                I work in English and Russian with clients across Europe and worldwide.
            </div>
              <div>
                I work with individuals navigating:
                <ul>
                
                 <li>Leadership pressure and high responsibility</li>
                 <li>Emotional overload and decision fatigue</li>
                 <li>Identity change, transitions and professional reinvention</li>
                <li>Perfectionism, inner criticism and boundary difficulties</li>
                <li>Cultural adaptation for international professionals</li>
                </ul>
               </div>
           </div>
        );
    } 
    if (props.lang === "RU") {
        return (
            <div class="content-wrapper">  
            <div>
                в разработке
            </div>
          
           </div>
        );
    }
}
export default WhyMe;
